var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-spinner"},_vm._l((Array(12)),function(_,i){return _c('div',{key:i})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }